import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/** Tela final de sucesso do cadastro. */
export function SuccessStep() {
  const { t } = useTranslation();
  return (
    <div className="text-center py-2">
      <div className="mx-auto mb-4 w-[72px] h-[72px] rounded-full bg-lime-300/30 flex items-center justify-center">
        <i className="fa fa-check text-[30px] text-lime-500" aria-hidden="true"></i>
      </div>
      <h2 className="text-[18px] font-bold text-navy-800 mb-2">{t('views.registration.success.title', 'Cadastro concluído!')}</h2>
      <p className="text-[13px] text-navy-700/80 leading-[1.6] mb-6 px-2">
        {t('views.registration.success.text', 'Sua conta foi confirmada com sucesso. Agora você já pode acessar e acompanhar o consumo da sua unidade.')}
      </p>
      <Link
        to="/login"
        className="inline-block w-full py-[12px] rounded-[22px] text-[13px] font-bold !text-navy-900 bg-lime-500 hover:bg-lime-400 transition-colors"
      >
        {t('views.registration.success.access_account', 'Acessar minha conta')}
      </Link>
    </div>
  );
}
